"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNil = void 0;
const is_undefined_1 = require("./is-undefined");
exports.isNil = (value) => is_undefined_1.isUndefined(value) || value === null;
//# sourceMappingURL=is-nil.js.map